const ActiveSuppComp = (props) => {
  if (!props?.data || Object.keys(props.data).length === 0) {
    return '';
  }

  const booleanKey = Object.keys(props.data).find(
    (key) => typeof props.data[key] === 'boolean'
  );

  if (!booleanKey) {
    return '';
  }

  const booleanValue = props.data[booleanKey];

  return booleanValue ? `☑` : '☐';
};

export default ActiveSuppComp;
